import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES } from "../../../utils/constant";
import { aesDecrypt } from "../../../utils/commonFunctionalities";

class Consignor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "consignorMaster"})
      .then(async(dataArray) => {
        if(dataArray?.data?.resultSet?.length){
          for(let data of dataArray.data.resultSet){
            if(data.gstNumber) data.gstNumber = await aesDecrypt(data.gstNumber);
          }
          this.setState({
            rowData: dataArray.data.resultSet,
            loadingData: false,
          });
        }else{
          this.setState({
            rowData: [],
            loadingData: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_CONSIGNOR_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-consignor", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/consignor");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: t("table_header.consignor_code") || "Consignor Code",
        field: "consignorCode",
        sortable: true,
        minWidth: '80px',
        filter: true,
      },
      {
        headerName: t("table_header.consignor_code") || "Consignor Code",
        field: "consignorId",
        hide: true
      },
      {
        headerName: t("table_header.consignor_name") || "Consignor Name",
        field: "consignorName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.city") || "City",
        field: "cityName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.consignor_address") || "Consignor Address",
        field: "address",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.email_id") || "Email Id",
        field: "email",
        sortable: true,
        filter: true,
        // hide: true
      },
      {
        headerName: t("table_header.mobile_number") || "Mobile Number",
        field: "phone",
        sortable: true,
        filter: true,
        // hide: true
      },
      {
        headerName: t("table_header.landline_number") || "Landline Number",
        field: "landline",
        sortable: true,
        filter: true,
        hide: true
      },
      {
        headerName: t("table_header.gst") || "Gst Number",
        field: "gstNumber",
        sortable: true,
        filter: true,
        // hide: true
      },
      {
        headerName:
          t("table_header.checkpoint_latitude") || "Checkpoint Latitude",
        field: "checkPointLattitude",
        sortable: true,
        filter: true,
        // hide: true
      },
      {
        headerName:
          t("table_header.checkpoint_longitude") || "Checkpoint Longitude",
        field: "checkPointLongitude",
        sortable: true,
        filter: true,
        // hide: true,
      },
      {
        headerName:
          t("table_header.checkpoint_radius") || "Checkpoint Radius",
        field: "checkPointRadius",
        sortable: true,
        filter: true,
        // hide: true,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_CONSIGNOR_MASTER.UPDATE && !this.props.permissions.TA_CONSIGNOR_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={t("title") || "Consignor"}
          titleBarLink={"/add-consignor"}
          baseURL={"consignorMaster"}
          pathName={"consignorMaster"}
          keyIndex={"consignorId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_CONSIGNOR_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_CONSIGNOR_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("consignor_list")(Consignor));
